import { useNavigate } from "react-router-dom";
import { Body, Inputs, NovaSubstratoContainer } from "./styles";
import { toast } from "react-toastify";
import api from "../../../../services/api";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAuth } from "../../../../providers/Auth/index";
import { NovoSubstratoSchema } from "../../../../schemas/novoCadastro";
import { ReactSVG } from "react-svg";
import voltar from "../../../../assets/voltar.svg";

const NovaSubstrato = () => {
  const {
    formState: { errors },
    handleSubmit,
    register,
  } = useForm({
    resolver: yupResolver(NovoSubstratoSchema),
  });
  const navigate = useNavigate();
  const { user } = useAuth();

  const onSubmitFunction = (data) => {
    const substratos = [data];
    api
      .post("/substrato", { substratos })
      .then((response) => {
        navigate("/substratos");
        toast.success("Substrato cadastrado com sucesso!");
      })
      .catch((error) => {
        console.error("Erro ao buscar dados da API:", error);
        toast.error("Erro ao buscar dados");
      });
  };

  return (
    <NovaSubstratoContainer onSubmit={handleSubmit(onSubmitFunction)}>
      <div className="box">
        <div className="flex">
          <ReactSVG
            onClick={() => navigate("/substratos")}
            className="voltar"
            src={voltar}
          />
          <div>
            <h1>Substratos</h1>
            <span className="underline">Novo Substrato</span>
          </div>
        </div>
        <Body>
          <div className="checkbox">
            <input
              type="checkbox"
              id="checkbox1"
              name="status"
              {...register("status")}
              defaultChecked={true}
            />

            <label htmlFor="checkbox1">Ativo</label>
          </div>
          <Inputs>
            <div>
              <label>Nome*</label>
              <input
                type="text"
                name="nome"
                {...register("nome")}
                placeholder="Nome do Substrato"
              />
              {errors.nome && (
                <span className="input-error-cadastro">
                  {errors.nome.message}
                </span>
              )}
            </div>
            <div>
              <label>Gramatura/Espessura*</label>
              <input
                type="text"
                name="gramatura_espessura"
                {...register("gramatura_espessura")}
                placeholder="Gramatura/Espessura"
              />
              {errors.gramatura_espessura && (
                <span className="input-error-cadastro">
                  {errors.gramatura_espessura.message}
                </span>
              )}
            </div>
            <div className=" margin-bottom-40px">
              <label htmlFor="checkbox-reciclado">Reciclado</label>
              <input type="checkbox" className="checkbox-input" id="checkbox-reciclado" name="status" {...register("reciclado")} defaultChecked={true} />
            </div>
            <div className="margin-bottom-40px">
              <label htmlFor="checkbox-certificado">Certificado</label>
              <input type="checkbox" className="checkbox-input" id="checkbox-certificado" name="status" {...register("certificado")} defaultChecked={true} />
            </div>
            <div className="margin-bottom-40px">
              <label htmlFor="checkbox-reciclavel">Reciclável</label>
              <input type="checkbox" className="checkbox-input" id="checkbox-reciclavel" name="status" {...register("reciclavel")} defaultChecked={true} />
            </div>
          </Inputs>
        </Body>
        <div className="buttons">
          {user && user.permissoes.includes("itens_criar") && (
            <button type="submit">Salvar</button>
          )}
        </div>
      </div>
    </NovaSubstratoContainer>
  );
};

export default NovaSubstrato;
